type ReporterOptions = {
   shouldReport: () => boolean;
   capture: (message: string, tags: Record<string, string>) => void;
};

// #63967: blocked sprite fetches fire error on healthy sprites; the verify
// fetch filters them (a throw is the same block, stays silent).
const VERIFY_FETCH_BUDGET = 3;

export function createFailedUseHrefReporter({ shouldReport, capture }: ReporterOptions) {
   const reportedUseHrefs = new Set<string>();
   let verifyFetchesLeft = VERIFY_FETCH_BUDGET;
   return function reportFailedUseHref(href: string) {
      if (!shouldReport() || verifyFetchesLeft <= 0 || reportedUseHrefs.has(href)) {
         return;
      }
      reportedUseHrefs.add(href);
      verifyFetchesLeft--;
      fetch(href).then(
         response => {
            if (response.ok) {
               return;
            }
            // Tags split a real CDN miss from a client whose blocker answers
            // with a status instead of dropping the request.
            capture(`svg <use> failed to load: ${href} (HTTP ${response.status})`, {
               iconDiagnostic: 'true',
               responseContentType: response.headers.get('content-type') ?? '(none)',
               responseRedirected: String(response.redirected),
            });
         },
         () => {}
      );
   };
}
